import { Stack } from 'expo-router';
import React from 'react';

function VaroAdvanceLayout() {
  return <Stack />;
}

export default VaroAdvanceLayout;
